var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video',{ref:"video",attrs:{"src":_vm.url,"controls":"controls"}},[_vm._v(" 您的浏览器不支持 video 标签。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }